import { Text, type Node } from 'slate';

export const emptyTextNode = (node: Node) =>
  Text.isText(node) && /^\s*$/.test(node.text);
